/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum TussentijdseUitstroomVSOStatus {
    INFORMATIE_VOLLEDIG = "Informatie volledig",
    GEEN_SCHOOL_VAN_BESTEMMING_GEREGISTREERD = "Geen school van bestemming geregistreerd",
    ONBEKENDE_SCHOOLSOORT_SV_B = "Onbekende schoolsoort SvB",
    NIET_UITGESCHREVEN = "Niet uitgeschreven",
    REGISTRATIE_NIET_BE_INDIGD = "Registratie niet be\u00EBindigd",
    GEEN_TUSSENTIJDSE_UITSTROOM = "Geen tussentijdse uitstroom"
}
